var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComposerNotesActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.25 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1.25h9.5a1.25 1.25 0 0 1 1.25 1.25v10.5a1.25 1.25 0 0 1-1.25 1.25h-9.5a1.25 1.25 0 0 1-1.25-1.25V2.5A1.25 1.25 0 0 1 1.25 1.25z",
    fill: "none",
    stroke: "#1450ff",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 1.25,
    x2: 4,
    y2: 14.25,
    stroke: "#1450ff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 5.5,
    x2: 10.75,
    y2: 5.5,
    stroke: "#1450ff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 8,
    x2: 10.75,
    y2: 8,
    stroke: "#1450ff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.25,
    y1: 10.5,
    x2: 9.25,
    y2: 10.5,
    stroke: "#1450ff",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComposerNotesActiveIcon);
export default __webpack_public_path__ + "static/media/composer-notes-active-icon.ed876c521a0af2ec100d7a2f40aa5818.svg";
export { ForwardRef as ReactComponent };